import { useEffect, useState } from "react";
import axios from "axios";
import IllustrationTile, { themeNameFromUrl } from "@/components/IllustrationTile";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { id: "f1", url: "illustration:crayons", label: "Colouring in" },
  { id: "f2", url: "illustration:abc", label: "Letters & numbers" },
  { id: "f3", url: "illustration:books", label: "Story time" },
];

function resolveUrl(u) {
  return u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
}

export default function Gallery() {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/gallery?kind=gallery`).then((res) => {
      if (alive && Array.isArray(res.data) && res.data.length > 0) setItems(res.data);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  const spanClass = (i) => {
    const pattern = [
      "md:col-span-2 md:row-span-2",
      "",
      "",
      "md:row-span-2",
      "",
      "",
      "md:col-span-2",
      "",
    ];
    return pattern[i % pattern.length] || "";
  };

  return (
    <section id="gallery" className="relative py-20 md:py-28 bg-brand-cream" data-testid="gallery-section">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="uppercase tracking-widest text-sm font-bold text-brand-yellowDark">Life at the playgroup</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold text-brand-ink">
            A peek into our <span className="text-brand-red">happy days.</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-4 md:auto-rows-[220px]" data-testid="gallery-grid">
          {items.map((img, i) => {
            const theme = themeNameFromUrl(img.url);
            return (
              <div
                key={img.id}
                className={`relative overflow-hidden rounded-3xl border-[3px] border-brand-ink shadow-brutal-sm lift-hover ${spanClass(i)}`}
                data-testid={`gallery-item-${img.id}`}
              >
                {theme ? (
                  <IllustrationTile theme={theme} />
                ) : (
                  <img src={resolveUrl(img.url)} alt={img.label || "Playgroup moment"} className="w-full h-full object-cover" />
                )}
                {img.label && (
                  <span className="absolute bottom-3 left-3 bg-white border-2 border-brand-ink rounded-full px-3 py-1 text-xs font-bold shadow-brutal-sm">
                    {img.label}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
